import { TransportOrder } from "../model/transportorder/transportOrder"
import { State } from "./store"
import { searchInTransportOrders, sortTransportOrders } from "./transportorder.slice"

export const getOverviewTransportOrders
    = (store: State): TransportOrder[] => store.transportOrder.overviewTransportOrders

export const getCsvTransportOrders = (store: State): TransportOrder[] => sortTransportOrders(
    searchInTransportOrders(store.transportOrder.transportOrders, store.transportOrder.searchPhrase),
    store.transportOrder.sortCriteria
)
